module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "end-page"
  }, [(_vm.end) ? [_c('h2', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.end.title)
    }
  }), _vm._v(" "), (_vm.getWin) ? _c('p', {
    staticClass: "end-page__score"
  }, [_vm._v(_vm._s(_vm.getMoney) + " M€")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "end-page__characters"
  }, [_c('img', {
    attrs: {
      "src": _vm.end.character.img,
      "alt": _vm.end.character.name
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getPlayer.img,
      "alt": _vm.getPlayer.name
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "end-page__text",
    domProps: {
      "innerHTML": _vm._s(_vm.end.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "end-page__share"
  }, [_c('div', [_c('p', [_vm._v("Invitez vos amis à jouer")]), _vm._v(" "), _c('socials', {
    attrs: {
      "share": true
    }
  })], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "validate-action-back btn",
    attrs: {
      "to": "/choisir-son-personnage"
    },
    on: {
      "click": _vm.resetCookies
    }
  }, [_c('span'), _vm._v(" Recommencer l'aventure")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f4e8e94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/End.vue
// module id = 81
// module chunks = 0